/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Codec_LabelInputs */



/**
* | output |
* | --- |
* | "Audio codec" |
*
* @param {Audio_Embed_Export_Codec_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_codec_label = /** @type {((inputs?: Audio_Embed_Export_Codec_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Codec_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Codec audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio-Codec")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codec audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиокодек")
	if (locale === "es") return /** @type {LocalizedString} */ ("códec de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频编解码器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオコーデック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो कोडेक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Codec de áudio")
	return /** @type {LocalizedString} */ ("Audio codec")
});